import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'LusoLove';
const DEFAULT_DESCRIPTION = 'The dating platform made for Portuguese people living in Europe. Meet authentic Portuguese singles in France, Switzerland, Luxembourg, Germany, Belgium and beyond.';
const DEFAULT_IMAGE = '/lusolove-favicon.png';

export default function SEOHead({
  title,
  description = DEFAULT_DESCRIPTION,
  path = '',
  noindex = false,
  image,
  type = 'website',
}) {
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://lusolove.com';
  const canonicalUrl = `${origin}${path}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Portuguese Dating in Europe`;
  const ogImage = image || `${origin}${DEFAULT_IMAGE}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_GB" />
      <meta property="og:locale:alternate" content="pt_PT" />
      <meta property="og:locale:alternate" content="fr_FR" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
